/* eslint-disable */
/**
 * Animations
 *
 * Class that handles the animations
 */

class Animations {
    constructor() {
        this.slideshowSceneId = 'slideshow-scene';
        this.totalFrames = $('.slideshow__frame').length;
        this.slideshowLinkClass = 'slideshow__nav__link';
        this.activeStateClass = 'ative';
        this.slideshowFrameClass = 'slideshow__frame';
        this.slideshowFrameHeight = $(`.${this.slideshowFrameClass}`).outerHeight();
        this.isMobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    }

    init() {
        const self = this;
        const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true || window.matchMedia('print').matches === true;

        if (!isReduced && $('.slideshow').length > 0 && !self.isMobile) {
            const slideshow = self.slideshowAnimations(self);

            $(window).resize(() => {
                slideshow.disable();
                slideshow.enable();
                self.refreshSlideshowHeight(self);
            })
        } else {
            $('.slideshow').addClass('slideshow--disabled');
        }
    }

    /**
     *
     * Slideshow Animations
     *
     * @param {obj} self The Animations class object
     */
    slideshowAnimations(self = this) {
        $('.slideshow').addClass('slideshow--active');

        self.refreshSlideshowHeight(self);

        gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

        /* Main navigation */
        const headerHeight = $('.header').outerHeight();
        const slideshowTimeline = self.getTimeline(self);
        const totalSlides = gsap.utils.toArray(".slideshow__frame:not(#frame-1)").length;
        let slideShowScene;

        // Set the z-indexes
        gsap.set(".slideshow__frame", { zIndex: (i, target, targets) => targets.length - i } );

        // Initialize ScrollTrigger
        slideShowScene = ScrollTrigger.create({
            animation: slideshowTimeline,
            trigger: `.slideshow`,
            start: `top ${headerHeight}`,
            // start: `top top`,
            pin: true,
            scrub: true,
            end: `+=${(totalSlides * 100) + 400}%`,
            invalidateOnRefresh: true
        });

        // Scroll to navigation
        document.querySelectorAll(".slideshow__nav__link").forEach((anchor, index) => {
            const frameNum = index + 1;
            anchor.addEventListener("click", function (e) {
                e.preventDefault();
                const targetId = anchor.getAttribute("href");
                const frameLabel = targetId.replace('#', '');

                /**
                * Tweening first is more accurate than scrolling into position
                * because the tweenTo method does a better job at locking to the frame.
                * After the visual effect is done, we scroll the scroll bar into its
                * proper position so that the user can continue from that point.
                */
                slideshowTimeline.tweenTo(frameLabel, {
                    /**
                     * After the animation has been tweened to the frame's position,
                     * we then determine the scroll position of that frame and scroll
                     * the window to that position.
                     */
                    onComplete: () => {
                        var st = slideshowTimeline.scrollTrigger;
                        var pos = st.start + (st.end - st.start) * (slideshowTimeline.labels[frameLabel] / slideshowTimeline.duration());
                        gsap.to(window, {
                            scrollTo: pos, duration: 0
                        });
                    }
                }).duration(0);
            });
        });

        return slideShowScene;
    }

    refreshSlideshowHeight(self = this) {
        // Set the height of the slideshow
        $(".slideshow__frame, .slideshow").css('height',`${self.getSlideshowHeight()}px`);
    }

    getSlideshowHeight() {
        const headerHeight = $('.header').outerHeight();
        const windowHeight = $(window).outerHeight();
        const slideshowHeight = windowHeight - headerHeight;

        return slideshowHeight;
    }

    getTimeline(self = this) {
        let slideshowTimeline = gsap.timeline();

        ScrollTrigger.matchMedia({
            // desktop narrow height
            "(min-width: 768px) and (max-height: 799px)": function () {
                slideshowTimeline
                    // Hide frames after frame 1
                    .set('.slideshow__frame:not(#frame-1)', { top: '-100%' })

                    // Frame 1 Start
                    .addLabel('frame-1')
                    .to('.introduction__content', { y: '100%', opacity: 0, duration: 300 })

                    // Prepare Frame 2
                    .set('#frame-2', { top: 0 })
                    .set('.tuition__intro', { top: '0' })
                    .set('.tuition__intro__heading', { height: 0 })
                    .set('.tuition__heading', { height: 0 })
                    .set('.tuition__content', { height: 0 })
                    .set('.tuition__button', { height: 0 })

                    // Frame 1 End
                    .call(self.setActiveNavItem, ["frame-1"])
                    .to('#frame-1', { opacity: 0, duration: 200 })
                    .set('#frame-1', { top: '-100%' })

                    // Frame 2 Start
                    .call(self.setActiveNavItem, ["frame-2"])
                    .to('.tuition__intro__heading', { height: 'auto', duration: 200 })

                    // Animate Frame 2
                    .to('.tuition__intro', { opacity: 0, duration: 500 })
                    .set('.tuition__intro', { top: '-100%' })
                    .to('.tuition__heading', { height: 'auto', duration: 250 })
                    .to('.tuition__content', { height: 'auto', duration: 130 })
                    .to('.tuition__button', { height: 'auto', duration: 130 })
                    .addLabel('frame-2')

                    // Prepare Frame 3
                    .set('#frame-3', { top: 0 })
                    .set('.overview__item', { top: '100vh' })
                    .set('.overview__item__content__num', { top: '50vh' })
                    .set('.overview__item__content p', { top: '80vh' })
                    .set('.education__heading, .education__list li', { height: 0 })
                    .set('.education__cover', { top: 0 })

                    //Frame 2 End
                    .call(self.setActiveNavItem, ["frame-2"])
                    .to('#frame-2', { opacity: 0, duration: 200 })
                    .set('#frame-2', { top: '-100%' })

                    // Frame 3 Start
                    .call(self.setActiveNavItem, ["frame-3"])
                    .addLabel('frame-3', '>+670')

                    // Animate Frame 3
                    .to('.overview__item--1', { top: '-100vh', duration: 2000 }, '>-0.2')
                    .to('.overview__item--1 .overview__item__content__num', { top: 0, duration: 1500 }, '<')
                    .to('.overview__item--1 .overview__item__content p', { top: 0, duration: 1250 }, '<')

                    .to('.overview__item--2', { top: '-100vh', duration: 2000 }, '>-20')
                    .to('.overview__item--2 .overview__item__content__num', { top: 0, duration: 1500 }, '<')
                    .to('.overview__item--2 .overview__item__content p', { top: 0, duration: 1250 }, '<')

                    .to('.overview__item--3', { top: '-100vh', duration: 2000 }, '>-100')
                    .to('.overview__item--3 .overview__item__content__num', { top: 0, duration: 1500 }, '<')
                    .to('.overview__item--3 .overview__item__content p', { top: 0, duration: 1250 }, '<')

                    // Set Frame 3 active
                    .set('#frame-4', { top: 0 }, '>-250')
                    .to('#frame-3', {
                        opacity: 0, duration: 500, onReverseComplete: () => {
                            self.setActiveNavItem('frame-3');
                        }
                    }, '>')

                    // Prepare Frame 4
                    .set('#frame-3', { top: '-100%' }, '>')

                    // Frame 4
                    .call(self.setActiveNavItem, ["frame-4"], '>')

                    // Animate Frame 4
                    .to('.education__heading', { height: 'auto', duration: 500 }, '>')
                    .set('.education__image--side', { right: '-100%' })
                    .to('.education__heading', {
                        height: 0,
                        onComplete: () => {
                            $('.education__content').css({ 'z-index': 4 });
                            $('.education__image--side').css({ 'z-index': 4 });
                        },
                        duration: 500
                    })
                    .to('.education__list li', {
                        height: 'auto',
                        onReverseComplete: () => {
                            $('.education__content').css({ 'z-index': 1 });
                            $('.education__image--side').css({ 'z-index': 2 })
                        },
                        duration: 150
                    })
                    .to('.education__image--side', {
                        right: 0,
                        boxShadow: '-50px 0 130px 26px black',
                        duration: 500
                    },
                        '>-0.5')
                    .addLabel('frame-4', '>')
                    .to('.education__image--side', {
                        width: '100%',
                        duration: 500
                    }, '>-1')

                    // Prepare Frame 5
                    .set('#frame-5', { top: 0 })
                    .set('.opportunities__heading, .opportunities__list li', { height: 0 })
                    .set('.opportunities__cover', { top: 0 })

                    // Hide Frame 4
                    .call(self.setActiveNavItem, ["frame-4"])
                    .to('#frame-4', { opacity: 0, duration: 200 })
                    .set('#frame-4', { top: '-100%' })

                    // Frame 5 Start
                    .call(self.setActiveNavItem, ["frame-5"])

                    // Animate Frame 5
                    .to('.opportunities__heading', { height: 'auto', duration: 550 })
                    .set('.opportunities__image--side', { right: '-100%', width: 0 })
                    .to('.opportunities__heading', {
                        height: 0,
                        onComplete: () => {
                            $('.opportunities__content').css({ 'z-index': 4 });
                            $('.opportunities__image--side').css({ 'z-index': 4 });
                        },
                        duration: 550
                    })
                    .to('.opportunities__list li', {
                        height: 'auto',
                        onReverseComplete: () => {
                            $('.opportunities__content').css({ 'z-index': 1 });
                            $('.opportunities__image--side').css({ 'z-index': 2 })
                        },
                        duration: 250
                    })
                    .to('.opportunities__image--side', {
                        right: 0,
                        boxShadow: '-50px 0 130px 26px black',
                        duration: 500
                    }, '>-250')
                    .addLabel('frame-5', '>+150')
                    .to('.opportunities__image--side', {
                        width: '100%',
                        duration: 500
                    }, '>-1')

                    // Prepare Frame 6
                    .set('#frame-6', { top: '0' })
                    .set('.experience__heading', { opacity: 0 })

                    // Hide Frame 5
                    .call(self.setActiveNavItem, ["frame-5"])
                    .to('#frame-5', { opacity: 0, duration: 200 })
                    .set('#frame-5', { top: '-100%' })

                    // Frame 6 Start
                    .call(self.setActiveNavItem, ["frame-6"])

                    // Animate Frame 6
                    .to('.slideshow__nav__list__item', { color: 'black' })
                    .to('.experience__heading', { duration: 200, opacity: 1 })
                    .addLabel('frame-6');
            },
            // desktop tall height
            "(min-width: 768px) and (min-height: 800px)": function () {
                slideshowTimeline
                    // Hide frames after frame 1
                    .set('.slideshow__frame:not(#frame-1)', { top: '-100%' })

                    // Frame 1 Start
                    .addLabel('frame-1')
                    .to('.introduction__content', { y: '100%', opacity: 0, duration: 300 })

                    // Prepare Frame 2
                    .set('#frame-2', { top: 0 })
                    .set('.tuition__intro', { top: '0' })
                    .set('.tuition__intro__heading', { height: 0 })
                    .set('.tuition__heading', { height: 0 })
                    .set('.tuition__content', { height: 0 })
                    .set('.tuition__button', { height: 0 })

                    // Frame 1 End
                    .call(self.setActiveNavItem, ["frame-1"])
                    .to('#frame-1', { opacity: 0, duration: 500})
                    .set('#frame-1', { top: '-100%' })

                    // Frame 2 Start
                    .call(self.setActiveNavItem, ["frame-2"])
                    .to('.tuition__intro__heading', { height: 'auto', duration: 200 })

                    // Animate Frame 2
                    .to('.tuition__intro', { opacity: 0, duration: 500})
                    .set('.tuition__intro', { top: '-100%' })
                    .to('.tuition__heading', { height: 'auto', duration: 250 })
                    .to('.tuition__content', { height: 'auto', duration: 130 })
                    .to('.tuition__button', { height: 'auto', duration: 130 })
                    .addLabel('frame-2')

                    // Prepare Frame 3
                    .set('#frame-3', { top: 0 })
                    .set('.overview__item', { top: '100vh' })
                    .set('.overview__item__content__num', { top: '50vh' })
                    .set('.overview__item__content p', { top: '80vh' })
                    .set('.education__heading, .education__list li', { height: 0 })
                    .set('.education__cover', { top: 0 })

                    //Frame 2 End
                    .call(self.setActiveNavItem, ["frame-2"])
                    .to('#frame-2', { opacity: 0, duration: 200 })
                    .set('#frame-2', { top: '-100%' })

                    // Frame 3 Start
                    .call(self.setActiveNavItem, ["frame-3"])
                    .addLabel('frame-3', '>+600')

                    // Animate Frame 3
                    .to('.overview__item--1', { top: '-100vh', duration: 2000 }, '>-0.2')
                    .to('.overview__item--1 .overview__item__content__num', { top: 0, duration: 1500 }, '<')
                    .to('.overview__item--1 .overview__item__content p', { top: 0, duration: 1100 }, '<')

                    .to('.overview__item--2', { top: '-100vh', duration: 2000 }, '>-250')
                    .to('.overview__item--2 .overview__item__content__num', { top: 0, duration: 1500 }, '<')
                    .to('.overview__item--2 .overview__item__content p', { top: 0, duration: 1200 }, '<')

                    .to('.overview__item--3', { top: '-70vh', duration: 2000 }, '>-450')
                    .to('.overview__item--3 .overview__item__content__num', { top: 0, duration: 1500 }, '<')
                    .to('.overview__item--3 .overview__item__content p', { top: 0, duration: 1250 }, '<')

                    // Set Frame 3 active
                    .set('#frame-4', { top: 0 }, '>-250')
                    .to('#frame-3', { opacity: 0, duration: 500, onReverseComplete: () => {
                        self.setActiveNavItem('frame-3');
                        }
                    }, '<')
                    .set('#frame-3', { top: '-100%' }, '>')
                    // Prepare Frame 4

                    // Frame 4
                    .call(self.setActiveNavItem, ["frame-4"], '>')

                    // Animate Frame 4
                    .to('.education__heading', { height: 'auto', duration: 500 }, '>')
                    .set('.education__image--side', { right: '-100%'})
                    .to('.education__heading', {
                        height: 0,
                        onComplete: () => {
                            $('.education__content').css({ 'z-index': 4 });
                            $('.education__image--side').css({ 'z-index': 4 });
                        },
                        duration: 500
                    })
                    .to('.education__list li', {
                        height: 'auto',
                        onReverseComplete: () => {
                            $('.education__content').css({ 'z-index': 1 });
                            $('.education__image--side').css({ 'z-index': 2 })
                        },
                        duration: 150
                    })
                    .to('.education__image--side', {
                        right: 0,
                        boxShadow: '-50px 0 130px 26px black',
                        duration: 500
                    },
                        '>-0.5')
                    .addLabel('frame-4', '>')
                    .to('.education__image--side', {
                        width: '100%',
                        duration: 500
                    }, '>-1')

                    // Prepare Frame 5
                    .set('#frame-5', { top: 0 })
                    .set('.opportunities__heading, .opportunities__list li', { height: 0 })
                    .set('.opportunities__cover', { top: 0 })

                    // Hide Frame 4
                    .call(self.setActiveNavItem, ["frame-4"])
                    .to('#frame-4', { opacity: 0, duration: 200})
                    .set('#frame-4', { top: '-100%' })

                    // Frame 5 Start
                    .call(self.setActiveNavItem, ["frame-5"])

                    // Animate Frame 5
                    .to('.opportunities__heading', { height: 'auto', duration: 550 })
                    .set('.opportunities__image--side', { right: '-100%', width: 0 })
                    .to('.opportunities__heading', {
                        height: 0,
                        onComplete: () => {
                            $('.opportunities__content').css({ 'z-index': 4 });
                            $('.opportunities__image--side').css({ 'z-index': 4 });
                        },
                        duration: 550
                    })
                    .to('.opportunities__list li', {
                        height: 'auto',
                        onReverseComplete: () => {
                            $('.opportunities__content').css({ 'z-index': 1 });
                            $('.opportunities__image--side').css({ 'z-index': 2 })
                        },
                        duration: 250
                    })
                    .to('.opportunities__image--side', {
                        right: 0,
                        boxShadow: '-50px 0 130px 26px black',
                        duration: 500
                    }, '>-250')
                    .addLabel('frame-5', '>+150')
                    .to('.opportunities__image--side', {
                        width: '100%',
                        duration: 500
                    }, '>-1')

                    // Prepare Frame 6
                    .set('#frame-6', { top: '0' })
                    .set('.experience__heading', { opacity: 0 })

                    // Hide Frame 5
                    .call(self.setActiveNavItem, ["frame-5"])
                    .to('#frame-5', { opacity: 0, duration: 200 })
                    .set('#frame-5', { top: '-100%' })

                    // Frame 6 Start
                    .call(self.setActiveNavItem, ["frame-6"])

                    // Animate Frame 6
                    .to('.slideshow__nav__list__item', { color: 'black' })
                    .to('.experience__heading', { duration: 200, opacity: 1 })
                    .addLabel('frame-6');
            },
            // mobile
            "(max-width: 767px)": function () {
                slideshowTimeline
                    // Hide frames after frame 1
                    .set('.slideshow__frame:not(#frame-1)', { top: '-100%' })

                    // Frame 1 Start
                    .addLabel('frame-1')
                    .to('.introduction__content', { y: '100%', opacity: 0, duration: 5 })

                    // Prepare Frame 2
                    .set('#frame-2', { top: 0 })
                    .set('.tuition__intro', { top: '0' })
                    .set('.tuition__intro__heading', { height: 0 })
                    .set('.tuition__heading', { height: 0 })
                    .set('.tuition__content', { height: 0 })
                    .set('.tuition__button', { height: 0 })

                    // Frame 1 End
                    .call(self.setActiveNavItem, ["frame-1"])
                    .to('#frame-1', { opacity: 0, duration: 3 })
                    .set('#frame-1', { top: '-100%' })

                    // Frame 2 Start
                    .call(self.setActiveNavItem, ["frame-2"])
                    .to('.tuition__intro__heading', { height: 'auto', duration: 3 })

                    // Animate Frame 2
                    .to('.tuition__intro', { opacity: 0 })
                    .set('.tuition__intro', { top: '-100%' })
                    .to('.tuition__heading', { height: 'auto', duration: 3 })
                    .to('.tuition__content', { height: 'auto', duration: 3 })
                    .to('.tuition__button', { height: 'auto', duration: 3 })
                    .addLabel('frame-2')

                    // Prepare Frame 3
                    .set('#frame-3', { top: 0 })
                    .set('.overview__item', { top: '100vh' })
                    .set('.overview__item__content__num', { top: '50vh' })
                    .set('.overview__item__content p', { top: '80vh' })
                    .set('.education__heading, .education__list li', { height: 0 })
                    .set('.education__cover', { top: 0 })

                    //Frame 2 End
                    .call(self.setActiveNavItem, ["frame-2"])
                    .to('#frame-2', { opacity: 0, duration: 2 })
                    .set('#frame-2', { top: '-100%' })

                    // Frame 3 Start
                    .call(self.setActiveNavItem, ["frame-3"])
                    .addLabel('frame-3', '>')

                    // Animate Frame 3
                    // Animate Frame 3
                    .to('.overview__item--1', { top: '-100vh', duration: 30 }, '>')
                    .to('.overview__item--1 .overview__item__content__num', { top: 0, duration: 20 }, '<')
                    .to('.overview__item--1 .overview__item__content p', { top: 0, duration: 15 }, '<')

                    .to('.overview__item--2', { top: '-100vh', duration: 30 }, '>-2')
                    .to('.overview__item--2 .overview__item__content__num', { top: 0, duration: 20 }, '<')
                    .to('.overview__item--2 .overview__item__content p', { top: 0, duration: 15 }, '<')

                    .to('.overview__item--3', { top: '-70vh', duration: 30 }, '>-5')
                    .to('.overview__item--3 .overview__item__content__num', { top: 0, duration: 20 }, '<')
                    .to('.overview__item--3 .overview__item__content p', { top: 0, duration: 15 }, '<')

                    // Set Frame 3 active
                    .set('#frame-4', { top: 0 }, '>-2')
                    .to('#frame-3', {
                        opacity: 0, duration: 1, onReverseComplete: () => {
                            self.setActiveNavItem('frame-3');
                        }
                    }, '>')
                    .set('#frame-3', { top: '-100%' }, '>')

                    // Prepare Frame 4

                    // Frame 4
                    .call(self.setActiveNavItem, ["frame-4"], '>')
                    .set('#frame-4', { top: 0 }, '>')

                    // Animate Frame 4
                    .to('.education__heading', { height: 'auto', duration: 3 }, '>-0.3')
                    .set('.education__image--side', { right: '-100%' })
                    .to('.education__heading', {
                        height: 0,
                        onComplete: () => {
                            $('.education__content').css({ 'z-index': 4 });
                            $('.education__image--side').css({ 'z-index': 4 });
                        },
                        duration: 3
                    })
                    .to('.education__list li', {
                        height: 'auto',
                        onReverseComplete: () => {
                            $('.education__content').css({ 'z-index': 1 });
                            $('.education__image--side').css({ 'z-index': 2 })
                        },
                        duration: 10
                    })
                    .addLabel('frame-4')
                    .to('.education__image--side', {
                        right: 0,
                        // width: '100%',
                        boxShadow: '-50px 0 130px 26px black',
                        duration: 10,
                    },
                        '>')

                    // Prepare Frame 5
                    .set('#frame-5', { top: 0 })
                    .set('.opportunities__heading, .opportunities__list li', { height: 0 })
                    .set('.opportunities__cover', { top: 0 })

                    // Hide Frame 4
                    .call(self.setActiveNavItem, ["frame-4"])
                    .to('#frame-4', { opacity: 0 })
                    .set('#frame-4', { top: '-100%' })

                    // Frame 5 Start
                    .call(self.setActiveNavItem, ["frame-5"])

                    // Animate Frame 5
                    .to('.opportunities__heading', { height: 'auto', duration: 5 })
                    .set('.opportunities__image--side', { right: '-100%' })
                    .to('.opportunities__heading', {
                        height: 0,
                        onComplete: () => {
                            $('.opportunities__content').css({ 'z-index': 4 });
                            $('.opportunities__image--side').css({ 'z-index': 4 });
                        },
                        duration: 5
                    })
                    .to('.opportunities__list li', {
                        height: 'auto',
                        onReverseComplete: () => {
                            $('.opportunities__content').css({ 'z-index': 1 });
                            $('.opportunities__image--side').css({ 'z-index': 2 })
                        },
                        duration: 10
                    })
                    .addLabel('frame-5')
                    .to('.opportunities__image--side', {
                        right: 0,
                        boxShadow: '-50px 0 130px 26px black',
                        duration: 10
                    }, '>')

                    // Prepare Frame 6
                    .set('#frame-6', { top: '0' })
                    .set('.experience__heading', { opacity: 0, duration: 3 })

                    // Hide Frame 5
                    .call(self.setActiveNavItem, ["frame-5"])
                    .to('#frame-5', { opacity: 0, duration: 2})
                    .set('#frame-5', { top: '-100%' })

                    // Frame 6 Start
                    .call(self.setActiveNavItem, ["frame-6"])

                    // Animate Frame 6
                    .to('.slideshow__nav__list__item', { color: 'black' })
                    .to('.experience__heading', { opacity: 1, duration: 2 })
                    .addLabel('frame-6');
            }
        });

        return slideshowTimeline;
    }

    setActiveNavItem(frameId) {
        $(`.slideshow__nav__link`).parent('li').removeClass('slideshow__nav__list__item--active')
        $(`.slideshow__nav__link--${frameId}`).parent('li').addClass('slideshow__nav__list__item--active')
    }

    onFrameAnimationStart(frame) {
        console.log('frame start =>', frame);
    }

    onFrameAnimationComplete(frame) {
        console.log('frame complete =>', frame);
    }

    /**
     * On Click Navigation
     *
     * This method allows a link with the data set of frame number, that
     * when clicked, will navigate to the frame.
     *
     * @param {object} scene the scene object of ScrollMagic instance
     * @param {object} controller the controller object of ScrollMagic instance
     * @param {object} animations the initialized animation object
     * @param {array} links an array of links that act as the navigators
     * @param {*} self the Timeline object
     */
    onClickNavigation(scene, controller, animations, links, self) {
        if (!controller || !scene) {
            return;
        }

        links.each((i, link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                const clickedLink = $(link);
                const frameTarget = $(clickedLink).attr('href');

                // Navigating to the frame
                self.goToFrame(frameTarget, scene, controller, animations, self);
            });
        });
    }

    /**
     * Go to Frame
     *
     * This method allows you to go to the specified frame in the scene.
     * The tweenTo method is used to tween the animations and onComplete
     * scroll the window to the location.
     *
     * @param {int} frameTarget
     * @param {object} scene the scene object of ScrollMagic instance
     * @param {object} controller the controller object of ScrollMagic instance
     * @param {object} animations the initialized animation object
     * @param {object} self the Timeline object
     */
    goToFrame(frameTarget, scene, controller, animations, self) {
        const sceneDuration = scene.duration();
        const durationPerFrame = sceneDuration / self.totalFrames;
        const frameObj = document.querySelector(frameTarget);
        const frameTargetCalc = $(`.${self.slideshowFrameClass}`).index(frameObj);
        let targetPosition = 0;
        let targetOffset = 0;

        /**
        * Tweening first is more accurate than scrolling into position
        * because the tweenTo method does a better job at locking to the frame.
        * After the visual effect is done, we scroll the scroll bar into its
        * proper position so that the user can continue from that point.
        */
        animations.tweenTo($(frameTarget).attr('id'), {
            /**
             * After the animation has been tweened to the frame's position,
             * we then determine the scroll position of that frame and scroll
             * the window to that position.
             */
            onComplete: () => {
                const sceneOffset = Math.abs(scene.scrollOffset());
                targetOffset = (frameTargetCalc * durationPerFrame);

                targetPosition = sceneOffset + targetOffset;

                controller.scrollTo(frameTarget);
            },
            onCompleteParams: [animations, controller, scene, frameTarget],
        }).duration(0);
    }

    /**
     * Set Active State
     *
     * Method used to add the `active` class to a clicked element
     * and clear the state from siblings.
     *
     * @param {object} interactedElement
     * @param {string} elementClass the class name of the element
     * @param {object} self the Timeline object
     */
    setActiveState(interactedElement, elementClass, self) {
        if (interactedElement) {
            // Get current active state
            const parent = (interactedElement) ? interactedElement.parentNode : document;
            const id = (interactedElement) ? `:not(#${interactedElement.id})` : null;
            const active_items = parent.querySelectorAll(`.${elementClass}.${self.activeStateClass}${id}`);

            if (active_items.length > 0) {
                // Loop through active state
                Array.prototype.forEach.call(active_items, (item) => {
                    // Remove the active class
                    item.classList.remove(self.activeStateClass);
                });
            }

            // Make item active
            if (!interactedElement.classList.contains(self.activeStateClass)) {
                interactedElement.classList.add(self.activeStateClass);
            }
        }
        return false;
    }
}

export default Animations;
